// extracted by mini-css-extract-plugin
export default {"wordsPage":"WordsPage_wordsPage__vGpdh","typingArea":"WordsPage_typingArea__bOI8k","buttonsWrapper":"WordsPage_buttonsWrapper__ST4MG"};